import React from 'react';
import classNames from 'classnames';

export class BlockList extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  get className () {
    return classNames({
      'blocklist': true,
      'blocklist--wrap': this.props.wrap 
    })
  }

  render = () => <div className={this.className}>{ this.props.children }</div>;
}
